const types = {
  ADD_COMPARE_DATA: 'calculation/ADD_COMPARE_DATA',
  REMOVE_COMPARE_DATA: 'calculation/REMOVE_COMPARE_DATA',
  IMPORT_GUIDE_PURPOSE_DATA: 'calculation/IMPORT_GUIDE_PURPOSE_DATA',
  SHOW_COMPARE_DATA: 'calculation/SHOW_COMPARE_DATA',
  HIDE_COMPARE_DATA: 'calculation/HIDE_COMPARE_DATA'
}

// @FIXME: 拿掉 options
// 預設的空選項
const defaultOptions = () => {
  return {
    flv_second: [],
    freq: 2,
    demographics: {
      male: [],
      female: []
    },
    hourlies: [],
    interests: [],
    keywords: [],
    medias: {
      categories: []
    },
    cities: {
      regions: [],
      municipalities: []
    },
    isps: [],
    device_brands: []
  }
}

const state = {
  // @FIXME: 拿掉 options
  options: defaultOptions(),
  compareDataLimit: 10, // 比較上限
  compareDataList: [],
  selectedDataFromGuidePurpose: null // 從導引結果來的資料
}

const getters = {
  // 判斷是否已達比較上限
  isCompareDataLimit: state => state.compareDataList.length >= state.compareDataLimit
}

const actions = {
  // 新增比較
  addCompareData ({ commit }, data) {
    commit(types.ADD_COMPARE_DATA, data)
  },
  // 移除比較
  removeCompareData ({ commit }, index) {
    commit(types.REMOVE_COMPARE_DATA, index)
  },
  importGuidePurposeData ({ commit }, data) {
    commit(types.IMPORT_GUIDE_PURPOSE_DATA, data)
  },
  showCompareData ({ commit }, index) {
    commit(types.SHOW_COMPARE_DATA, index)
  },
  hideCompareData ({ commit }, index) {
    commit(types.HIDE_COMPARE_DATA, index)
  }
}

const mutations = {
  [types.ADD_COMPARE_DATA] (state, data) {
    state.compareDataList.push(data)
  },
  [types.REMOVE_COMPARE_DATA] (state, index) {
    state.compareDataList.splice(index, 1)
  },
  [types.IMPORT_GUIDE_PURPOSE_DATA] (state, data) {
    state.selectedDataFromGuidePurpose = data
  },
  [types.SHOW_COMPARE_DATA] (state, index) {
    state.compareDataList[index].shown = true
  },
  [types.HIDE_COMPARE_DATA] (state, index) {
    state.compareDataList[index].shown = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
